export const JEST_PLACEHOLDER_EMAIL_DOMAIN = 'jest.local';

export const isPlaceholderEmail = (email: string): boolean =>
  email.trim().toLowerCase().endsWith(`@${JEST_PLACEHOLDER_EMAIL_DOMAIN}`);

export const claimEmailPrefill = (accountEmail: string | null | undefined): string =>
  !accountEmail || isPlaceholderEmail(accountEmail) ? '' : accountEmail;

// local part: no whitespace or @. domain: dot-separated hostname labels and a 2+ letter tld
const CLAIM_EMAIL_PATTERN = /^[^\s@]+@(?:[A-Za-z0-9](?:[A-Za-z0-9-]*[A-Za-z0-9])?\.)+[A-Za-z]{2,}$/;

export const isValidClaimEmail = (email: string): boolean => {
  const trimmed = email.trim();
  return CLAIM_EMAIL_PATTERN.test(trimmed) && !isPlaceholderEmail(trimmed);
};

// every character but the @ is encoded, so the address cannot add mailto fields such as ?subject=
export const claimMailtoHref = (email: string): string =>
  `mailto:${encodeURIComponent(email.trim()).replace(/%40/g, '@')}`;
